import React from 'react'

// Components
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

// Utils
import dayjs from 'lib/dayjs'

// Types
import { DateInputProps } from './DateInput.types'

const DateInput: React.FC<DateInputProps> = ({
  label,
  date,
  handleDateChange,
  disabled = false,
  sx,
}) => {
  // Convert Date to Dayjs for the DatePicker
  const dayjsValue = date ? dayjs(date) : null

  // Handle change and convert back to Date
  const handleChange = (newValue: dayjs.Dayjs | null) => {
    const dateValue = newValue ? newValue.toDate() : null
    handleDateChange(dateValue)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePicker
        label={label}
        value={dayjsValue}
        onChange={handleChange}
        disabled={disabled}
        slotProps={{
          textField: {
            size: 'small',
            fullWidth: true,
            variant: 'outlined',
          },
        }}
        sx={{
          ...sx,
        }}
      />
    </LocalizationProvider>
  )
}

export default DateInput
